import { library } from '@fortawesome/fontawesome-svg-core';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faAngleDoubleLeft, faAngleDoubleRight, faExclamationCircle, faExclamationTriangle, faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faThumbsDown, faThumbsUp, faAngleDoubleLeft, faAngleDoubleRight, faExclamationCircle, faExclamationTriangle, faGlobeAmericas);

export { FontAwesomeIcon };
